import { clone } from '@vestigas/utils';

export default class DataExchange {
  constructor() {
    this.activeCustomerIds = [];
    this.exchangeDeliveryNotes = false;
    this.exchangeInvoices = false;
    this.exchangeOrders = false;
    this.furtherInformation = '';
    this.id = '';
    this.isExchangeViaPaper = false;
    this.knownIssues = '';
    this.receiverId = '';
    this.receiverName = '';
    this.senderId = '';
    this.senderName = '';
  }

  init(dataExchange) {
    this.id = dataExchange?.id ?? '';
    this.senderId = dataExchange?.senderId ?? '';
    this.senderName = dataExchange?.senderName ?? '';
    this.receiverId = dataExchange?.receiverId ?? '';
    this.receiverName = dataExchange?.receiverName ?? '';
    this.isExchangeViaPaper = dataExchange?.isExchangeViaPaper ?? false;
    this.exchangeDeliveryNotes = dataExchange?.exchangeLfs ?? false;
    this.exchangeInvoices = dataExchange?.exchangeInvoices ?? false;
    this.exchangeOrders = dataExchange?.exchangeOrders ?? false;
    this.activeCustomerIds = dataExchange?.activeCustomerIds ?? [];
    this.knownIssues = dataExchange?.knownIssues ?? '';
    this.furtherInformation = dataExchange?.furtherInformation ?? '';
  }

  clone(dataExchange) {
    // TODO: Doesn't this create a copy by reference, which can lead to the most disgusting bugs? Use proper cloning.
    this.id = dataExchange?.id;
    this.senderId = dataExchange?.senderId;
    this.senderName = dataExchange?.senderName;
    this.receiverId = dataExchange?.receiverId;
    this.receiverName = dataExchange?.receiverName;
    this.isExchangeViaPaper = dataExchange?.isExchangeViaPaper;
    this.exchangeDeliveryNotes = dataExchange?.exchangeDeliveryNotes;
    this.exchangeInvoices = dataExchange?.exchangeInvoices;
    this.exchangeOrders = dataExchange?.exchangeOrders;
    this.activeCustomerIds = clone(dataExchange?.activeCustomerIds);
    this.knownIssues = dataExchange?.knownIssues;
    this.furtherInformation = dataExchange?.furtherInformation;
  }

  static isValid(dataExchange) {
    if (!dataExchange) return false;
    if (!dataExchange.senderId) return false;
    if (!dataExchange.receiverId) return false;

    // This validation logic is implemented in the backend.
    // However, from the business point of view, it doesn't make sense. For example, we want to track if delivery notes are exchange via paper way to know about the supplier network of our customers and leads.
    // Therefore, keep in mind that the backend logic needs to be adjusted in the future.
    if (dataExchange.isExchangeViaPaper)
      return (
        !dataExchange.exchangeDeliveryNotes &&
        !dataExchange.exchangeInvoices &&
        !dataExchange.exchangeOrders &&
        dataExchange.activeCustomerIds.length === 0
      );

    return true;
  }
}
